/**
 * LDG Module — Learning Dependency Graph exports.
 *
 * ARCHITECTURE v4.0 — Phase 1
 */

// Types
export type { LDGNode, LDGEdge, LDGraph, LDGMetadata, FrontierFamily, FrontierResult, FamilyMasteryInput, DAGValidationResult, DAGValidationError, PrerequisiteDefinition } from './types';

// Builder
// NOTE: stab-ronde 2 — `getAncestors`, `getDescendants`, `isPrerequisiteOf`
// verwijderd uit bron (nul callers). `validateDAG` en `GET_PREREQUISITES`
// verwijderd uit deze barrel (interne consumers gebruiken directe imports).
export { buildLDG, calculateFrontier } from './ldgBuilder';

// Prerequisites
export { ALL_PREREQUISITES } from './prerequisites';

// ─── Shared LDG Singleton ─────────────────────────────────────────────────────

import type { LDGraph } from './types';
import { buildLDG } from './ldgBuilder';
import { ALL_PREREQUISITES } from './prerequisites';
let _ldgInstance: LDGraph | null = null;

/**
 * Get the shared LDG graph instance (built once, cached).
 * Used by adaptive engine, RecommendedModes, and any component
 * that needs access to the learning dependency graph.
 */
export function getLDG(): LDGraph {
  if (!_ldgInstance) {
    _ldgInstance = buildLDG(ALL_PREREQUISITES);
  }
  return _ldgInstance;
}